import React from "react";
import { History } from "lucide-react";

const ACTION_COLORS = {
  CREATED: "bg-blue-900",
  UPDATED: "bg-slate-500",
  APPROVED: "bg-emerald-600",
  REJECTED: "bg-red-600",
  REVISED: "bg-amber-500",
  QUOTED: "bg-indigo-600",
  MARKED_LOST: "bg-red-500",
  CONVERTED: "bg-emerald-700",
  ACCEPTED: "bg-emerald-600",
  CANCELLED: "bg-red-600",
  CONFIRMED: "bg-emerald-700",
};

export default function AuditTrail({ items = [] }) {
  if (!items?.length) {
    return <div className="text-xs text-slate-400">No audit history yet.</div>;
  }
  const reversed = [...items].reverse();
  return (
    <ol className="relative border-l-2 border-slate-200 ml-2 space-y-4">
      {reversed.map((h, idx) => (
        <li key={idx} className="pl-5 relative" data-testid={`audit-item-${idx}`}>
          <div className={`absolute -left-[9px] top-1 w-4 h-4 rounded-full border-2 border-white ${ACTION_COLORS[h.action] || "bg-slate-500"}`} />
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-[10px] uppercase tracking-wider font-bold text-slate-800 font-mono">
              {h.action?.replaceAll("_", " ")}
            </span>
            <span className="text-[10px] text-slate-400 uppercase tracking-wider">by</span>
            <span className="text-xs font-semibold text-slate-700">{h.by_name}</span>
            <span className="text-[10px] text-slate-400">({h.by_role})</span>
          </div>
          <div className="text-[11px] text-slate-500 mt-0.5">
            {h.at ? new Date(h.at).toLocaleString() : "—"}
          </div>
          {h.remarks && (
            <div className="mt-1 text-xs text-slate-600 italic">"{h.remarks}"</div>
          )}
        </li>
      ))}
    </ol>
  );
}
